import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { GetGates, CreateGate, ClearGates } from '../../store/actions/gateActions'; 
import { TextInput } from 'react-materialize';
import InputAdornment from '@material-ui/core/InputAdornment';
import AccountCircle from '@material-ui/icons/AccountCircle';
import DialpadIcon from '@material-ui/icons/Dialpad';
import { Button, Modal, Table, Input } from 'antd';
import { Redirect } from 'react-router-dom';
import { TextField } from '@material-ui/core';
import Phone from '@material-ui/icons/Phone';
import validator from 'validator';
import _ from 'lodash';

const { Search } = Input;

function GateList(props) {
    const [form, setFormData] = useState(
        { 
            name: "", 
            max_id: "",
            greeting: "",
            callMsg: "",
            address: "",
            forceCode: "",
            admin_name: "",
            admin_phone: "",
            admin_keycode: "",
            admin_wiegand: "",
            admin_textOnOpen:       false, //data.admin_textOnOpen,
            admin_textOnTamper:     false, //data.admin_textOnTamper,
            admin_textOnSensorFail: false, //data.admin_textOnSensorFail,
        }
    );
    const [searchGate, setSearch]      = useState("");
    const [isLoading, setLoading]      = useState(true);
    const [isCreating, setCreating]    = useState(false);
    const [modalView, setModalView]    = useState(false);
    const [redirectId, setRedirectID]  = useState("");

    useEffect(() => {
        const subGates = async () => {
            return await props.GetGates();
        }
        if(isLoading == true) {
            setLoading(false);
            let unsubGates = subGates();
            return async () => {
                let unsubG = await unsubGates; 
                unsubG();
                props.ClearGates();
            };
        }
    },[]);
  
    const FormChange = (e) => {
        let formData = form;
        formData[e.target.name] = e.target.value;
        setFormData(formData);
    }
    const handleOk = () => {
        setCreating(true);
        
        if(!validator.isAlphanumeric(validator.blacklist(form.name,' '))) {
            alert("Site Name must be Alphanumeric");
            setCreating(false);
            return;
        }

        if(validator.isEmpty(form.name)) {
            alert("Site Name is required and can not be empty");
            setCreating(false);
            return;
        }

        if(validator.isEmpty(form.max_id)) {
            alert("Max ID is required and can not be empty");
            setCreating(false);
            return;
        }

        if(validator.isEmpty(form.admin_name)) {
            alert("An admin is required to be added to the Gate");
            setCreating(false);
            return;
        }

        if(validator.isEmpty(form.admin_phone)) {
            alert("An admin phone number is required to be added to the Gate");
            setCreating(false);
            return;
        }

        _CreateGate();
    };
    
    const _CreateGate = async () => {
        let gate = await props.CreateGate(form);
        setRedirectID(gate);
    }
    
    const handleCancel = () => {
        // setState({
        //     visible: false,
        // });
    };

    let gate = [];
    if(searchGate) {
        let search = searchGate.toLowerCase();
        let gates = props.gates.filter( gate => gate.max_id !== undefined );
        console.log(gates);
        gate = gates.filter(gate =>
            gate.name.toLowerCase().includes(search) ||
            gate.address.toLowerCase().includes(search) ||
            gate.max_id.toLowerCase().includes(search)
        );
        console.log(gate);
    } else {
        gate = _.isEmpty(props.gates) ? [] : props.gates;

    }

    gate = gate.sort((a,b) => {
        let gate_a = a.name.toUpperCase();
        let gate_b = b.name.toUpperCase();
        let comparison = 0;
        if (gate_a > gate_b) {
            comparison = 1;
        } else if (gate_a < gate_b) {
            comparison = -1;
        }
        return comparison;
    });

    const columns = [
        {
            title: 'Gate Site',
            dataIndex: 'name',
            width: '25%',
        },
        {
            title: 'Address',
            dataIndex: 'address',
            width: '30%',
        },
        {
            title: 'Max ID',
            dataIndex: 'max_id',
        },
        {
            title: 'Status',
            dataIndex: 'lastSeen',
            render: lastSeen => lastSeen > 118821351 ? <span style={{color: "green"}}>Online</span> : <span style={{color: "red"}}>Offline</span>,
            width: '10%'
        },
        ];


    if (redirectId !== "") {
        return <Redirect push to={`/admin/gate/${redirectId}`} />;
    }

    //Render
    return (
        <div className="container">
            <div className="col s12">
            <h2 style={{marginLeft: "10px", marginBottom: "0"}}>Gate List</h2>
                <Table
                    title={() => 
                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            <div style={{display: "flex", justifyContent: "space-around", alignItems: "baseline"}}>
                                <Button type="primary" onClick={() => setModalView(true)}>Add a Gate Site</Button>
                            </div>
                            <Search
                                placeholder="Search"
                                enterButton="Search"
                                size="large"
                                onSearch={value => setSearch(value)}
                                style={{ width: 335 }}
                            />
                        </div>
                    }
                    columns={columns}
                    rowKey={gate => gate.id}
                    dataSource={gate}
                    loading={isLoading}
                    pagination={{ pageSize: 12 }}
                    onRow={(record, rowIndex) => {
                        return {
                            onClick: e => setRedirectID(record.id), // click row
                        };
                    }}
                />
                <Modal
                    title="Add a Gate Site"
                    visible={modalView}
                    onOk={handleOk}
                    confirmLoading={isCreating}
                    onCancel={() => setModalView(false)}
                >
                <div className="createGate">
                    <div className="col s12">
                        <TextField variant="outlined" onChange={e => FormChange(e)} fullWidth name="name" label="Site Name" />
                    </div>
                    <div className="col s12">
                        <TextField variant="outlined" onChange={e => FormChange(e)} fullWidth name="address" label="Address" />
                    </div>
                    <div className="col s12">
                        <TextField variant="outlined"  inputProps={{maxLength: 15}} onChange={e => FormChange(e)} fullWidth name="max_id" label="MAX Cell Module ID" />
                    </div>
                    <div className="col s12">
                        <TextField variant="outlined" onChange={e => FormChange(e)} fullWidth name="greeting" label="Greetings" />
                    </div>
                    <div className="col s12">
                        <TextField variant="outlined" onChange={e => FormChange(e)} fullWidth name="callMsg" label="Call Button Message" />
                    </div>
                    <div className="col s12">
                        <TextField 
                            variant="outlined" 
                            onChange={e => FormChange(e)} 
                            fullWidth
                            name="forceCode" 
                            label="Force Open Keycode" 
                        />                    </div>
                    <hr style={{ border: "#eee 0.5px solid", margin: "25px 0" }}/>
                    <div className="col s12">
                        <TextField 
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <AccountCircle />
                                    </InputAdornment>
                                ),
                            }} 
                            variant="outlined" 
                            onChange={e => FormChange(e)} 
                            fullWidth
                            name="admin_name" 
                            label="Admin Name" 
                        />
                    </div>
                    <div className="col s12">
                        <TextField         
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Phone />
                                    </InputAdornment>
                                ),
                            }} 
                            variant="outlined" 
                            onChange={e => FormChange(e)} 
                            fullWidth
                            name="admin_phone" 
                            label="Admin Phone" 
                        />
                    </div>
                    <div className="col s12">
                        <TextField 
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <DialpadIcon />
                                    </InputAdornment>
                                ),
                            }} 
                            variant="outlined" 
                            onChange={e => FormChange(e)} 
                            fullWidth
                            name="admin_keycode" 
                            label="Admin Keycode" 
                        />
                    </div>                      
                    <div className="col s12">
                        <TextField 
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <DialpadIcon />
                                    </InputAdornment>
                                ),
                            }} 
                            variant="outlined" 
                            onChange={e => FormChange(e)} 
                            fullWidth
                            name="admin_wiegand" 
                            label="Admin Wiegand" 
                        />
                    </div>                    
                </div>
                </Modal>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        auth:       state.firebase.auth,
        gates:      state.gate.gates,
    }
}

// const mapStateToProps = ({ firebase: { auth, profile } }) => ({
//     auth,
//     profile
// });

const mapDispatchToProps = (dispatch) => {
    return {
      GetGates:     () => dispatch(GetGates()),
      ClearGates:   () => dispatch(ClearGates()),
      CreateGate:   (formData) => dispatch(CreateGate(formData))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GateList);
